import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from "context/AuthContext";
import { useUser } from "context/UserContext";
import { Button, TextField, Typography, IconButton, Box, Chip } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import EditIcon from '@mui/icons-material/Edit';

const MiDescripcion = () => {
  const navigate = useNavigate();
  const { user, loading: authLoading, getToken } = useAuth();
  const { 
    descripcion: descripcionContext,
    profesion: profesionContext,
    labels: labelsContext,
    nombre: nombreContext,
    apellido: apellidoContext,
    email: emailContext,
    celular: celularContext,
    imagen: imagenContext,
    genero: generoContext,
    honorarios: honorariosContext,
    isDataLoaded,
    updateLocalData 
  } = useUser();
  const [descripcion, setDescripcion] = useState('');
  const [profesion, setProfesion] = useState('');
  const [especialidades, setEspecialidades] = useState([]);
  const [etiquetas, setEtiquetas] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [mensaje, setMensaje] = useState('');
  const [profesionalData, setProfesionalData] = useState({
    nombre: '',
    apellido: '',
    email: '',
    celular: '',
    imagen: '',
    genero: ''
  });

  // Estados para cambio de foto de perfil
  const [isUploadingImage, setIsUploadingImage] = useState(false);
  const [showCropModal, setShowCropModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [isProcessingCrop, setIsProcessingCrop] = useState(false);
  const [cropArea, setCropArea] = useState({ x: 50, y: 50, width: 200, height: 200 });
  const [isDragging, setIsDragging] = useState(false);
  const [isResizing, setIsResizing] = useState(false);
  const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
  const [resizeHandle, setResizeHandle] = useState(null);
  const [initialCropArea, setInitialCropArea] = useState(null);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [honorarios, setHonorarios] = useState(0);
  const [isShortScreen, setIsShortScreen] = useState(false);
  const fileInputRef = useRef(null);
  const imageRef = useRef(null);

  const baseURL = process.env.REACT_APP_BASE_URL;

  const especialidadesData = [
    { label: "Adolescentes", value: "adolescentes" },
    { label: "Adulto Mayor", value: "adulto-mayor" },
    { label: "Agorafobia", value: "agorafobia" },
    { label: "Análisis de Sueños", value: "analisis-de-suenos" },
    { label: "Anorexia", value: "anorexia" },
    { label: "Ansiedad", value: "ansiedad" },
    { label: "Arteterapia", value: "arteterapia" },
    { label: "Asperger", value: "asperger" },
    { label: "Ataques de Pánico", value: "ataques-de-panico" },
    { label: "Autismo", value: "autismo" },
    { label: "Biodescodificacion", value: "biodescodificacion" },
    { label: "Brainspotting", value: "brainspotting" },
    { label: "Bullying", value: "bullying" },
    { label: "Coaching", value: "coaching" },
    { label: "Counseling", value: "counseling" },
    { label: "Cristiano", value: "cristiano" },
    { label: "Dependencia Emocional", value: "dependencia-emocional" },
    { label: "Deportivo", value: "deportivo" },
    { label: "Depresión", value: "depresion" },
    { label: "Depresión en adolescentes", value: "depresion-en-adolescentes" },
    { label: "Depresión posparto", value: "depresion-posparto" },
    { label: "Duelo", value: "duelo" },
    { label: "EMDR", value: "emdr" },
    { label: "En español", value: "en-espanol" },
    { label: "En francés", value: "en-frances" },
    { label: "En inglés", value: "en-ingles" },
    { label: "En italiano", value: "en-italiano" },
    { label: "En línea", value: "en-linea" },
    { label: "En portugués", value: "en-portugues" },
    { label: "Enfermedad Crónica", value: "enfermedad-cronica" },
    { label: "Especialista en Abuso Infantil", value: "especialista-en-abuso-infantil" },
    { label: "Especialista en Adicciones", value: "especialista-en-adicciones" },
    { label: "Especialista en Alimentación", value: "especialista-en-alimentacion" },
    { label: "Especialista en Ansiedad", value: "especialista-en-ansiedad" },
    { label: "Especialista en Ataques de Pánico", value: "especialista-en-ataques-de-panico" },
    { label: "Especialista en Bipolaridad", value: "especialista-en-bipolaridad" },
    { label: "Especialista en burnout", value: "especialista-en-burnout" },
    { label: "Especialista en Cognitivo Conductual", value: "especialista-en-cognitivo-conductual" },
    { label: "Especialista en Depresión", value: "especialista-en-depresion" },
    { label: "Especialista en Duelo", value: "especialista-en-duelo" },
    { label: "Especialista en Fobia Social", value: "especialista-en-fobia-social" },
    { label: "Especialista en Narcisismo", value: "especialista-en-narcisismo" },
    { label: "Especialista en Psicoanálisis", value: "especialista-en-psicoanalisis" },
    { label: "Especialista en Separaciones", value: "especialista-en-separaciones" },
    { label: "Especialista en Sexología", value: "especialista-en-sexologia" },
    { label: "Especialista en TCA", value: "especialista-en-tca" },
    { label: "Especialista en TDAH", value: "especialista-en-tdah" },
    { label: "Especialista en TOC", value: "especialista-en-toc" },
    { label: "Especialista en Trastornos Alimenticios", value: "especialista-en-trastornos-alimenticios" },
    { label: "Especialista en Traumas", value: "especialista-en-traumas" },
    { label: "Estrés", value: "estres" },
    { label: "Estrés Laboral", value: "estres-laboral" },
    { label: "Estrés Postraumático", value: "estres-postraumatico" },
    { label: "Familiar", value: "familiar" },
    { label: "Forense", value: "forense" },
    { label: "Gestalt", value: "gestalt" },
    { label: "Hipnósis", value: "hipnosis" },
    { label: "Infantil", value: "infantil" },
    { label: "Insomnio", value: "insomnio" },
    { label: "Judicial", value: "judicial" },
    { label: "Junguiano", value: "junguiano" },
    { label: "Laboral", value: "laboral" },
    { label: "LGBTIQ+", value: "lgbtiq" },
    { label: "Logoterapia", value: "logoterapia" },
    { label: "Ludopatía", value: "ludopatia" },
    { label: "Meditación", value: "meditacion" },
    { label: "Mindfulness", value: "mindfulness" },
    { label: "Mitomanía", value: "mitomania" },
    { label: "Neuropsicología", value: "neuropsicologia" },
    { label: "Online", value: "online" },
    { label: "Para empresas", value: "para-empresas" },
    { label: "Para estudiantes universitarios", value: "para-estudiantes-universitarios" },
    { label: "Para sordos", value: "para-sordos" },
    { label: "Perinatal", value: "perinatal" },
    { label: "Perspectiva de Género", value: "perspectiva-de-genero" },
    { label: "Psicoanálisis", value: "psicoanalisis" },
    { label: "Psicoanalista", value: "psicoanalista" },
    { label: "Psicodiagnóstico", value: "psicodiagnostico" },
    { label: "Psicología Médica", value: "psicologia-medica" },
    { label: "Psicología Positiva", value: "psicologia-positiva" },
    { label: "Psiconeuroinmunoendocrinología", value: "psiconeuroinmunoendocrinologia" },
    { label: "Psicosomático", value: "psicosomatico" },
    { label: "Salud Mental", value: "salud-mental" },
    { label: "Sentido de la Vida", value: "sentido-de-la-vida" },
    { label: "Sexología", value: "sexologia" },
    { label: "Suicidio", value: "suicidio" },
    { label: "TDAH", value: "tdah" },
    { label: "TEPT", value: "tept" },
    { label: "Terapia Cognitivo Conductual", value: "terapia-cognitivo-conductual" },
    { label: "Terapia DBT", value: "terapia-dbt" },
    { label: "Terapia de Pareja", value: "terapia-de-pareja" },
    { label: "Terapia EMDR", value: "terapia-emdr" },
    { label: "Terapia Sistémica", value: "terapia-sistemica" },
    { label: "Terapia Vocacional", value: "terapia-vocacional" },
    { label: "Terapias Alternativas", value: "terapias-alternativas" },
    { label: "TOC", value: "toc" },
    { label: "Transpersonal", value: "transpersonal" },
    { label: "Trastorno Límite de la Personalidad", value: "trastorno-limite-de-la-personalidad" },
    { label: "Trastornos Alimenticios", value: "trastornos-alimenticios" },
    { label: "Trastornos de Personalidad", value: "trastornos-de-personalidad" },
    { label: "Violencia de Género", value: "violencia-de-genero" },
  ];

  useEffect(() => {
    // Kickout solo si Firebase confirma que no hay usuario autenticado
    if (!authLoading && !user) {
      navigate("/authentication/sign-in");
      return;
    }
  }, [navigate, user, authLoading]);

  // Cargar datos desde el contexto cuando estén disponibles
  useEffect(() => {
    if (isDataLoaded) {
      if (descripcionContext) setDescripcion(descripcionContext);
      if (profesionContext) setProfesion(profesionContext);
      if (labelsContext && Array.isArray(labelsContext)) setEspecialidades(labelsContext);
      if (honorariosContext) setHonorarios(honorariosContext);
      
      setProfesionalData({
        nombre: nombreContext || "",
        apellido: apellidoContext || "",
        email: emailContext || "",
        celular: celularContext || "",
        imagen: imagenContext || "",
        genero: generoContext || ""
      });
    }
  }, [isDataLoaded, descripcionContext, profesionContext, labelsContext, honorariosContext, nombreContext, apellidoContext, emailContext, celularContext, imagenContext, generoContext]);

  useEffect(() => {
    if (showCropModal && imageLoaded) {
      const handleGlobalMouseMove = (e) => {
        if (!imageRef.current) return;
        
        const rect = imageRef.current.getBoundingClientRect();
        let clientX, clientY;
        
        // Manejar tanto eventos de mouse como táctiles
        if (e.touches && e.touches[0]) {
          clientX = e.touches[0].clientX;
          clientY = e.touches[0].clientY;
        } else {
          clientX = e.clientX;
          clientY = e.clientY;
        }
        
        const mouseX = clientX - rect.left;
        const mouseY = clientY - rect.top;
        
        if (isDragging) {
          const newX = mouseX - dragOffset.x;
          const newY = mouseY - dragOffset.y;
          
          const maxX = rect.width - cropArea.width;
          const maxY = rect.height - cropArea.height;
          
          setCropArea(prev => ({
            ...prev,
            x: Math.max(0, Math.min(newX, maxX)),
            y: Math.max(0, Math.min(newY, maxY))
          }));
        } else if (isResizing && initialCropArea) {
          const deltaX = mouseX - (initialCropArea.x + dragOffset.x);
          const deltaY = mouseY - (initialCropArea.y + dragOffset.y);
          
          let newCropArea = { ...initialCropArea };
          
          switch (resizeHandle) {
            case 'top-left':
              newCropArea.x = Math.max(0, Math.min(initialCropArea.x + deltaX, initialCropArea.x + initialCropArea.width - 50));
              newCropArea.y = Math.max(0, Math.min(initialCropArea.y + deltaY, initialCropArea.y + initialCropArea.height - 50));
              newCropArea.width = initialCropArea.x + initialCropArea.width - newCropArea.x;
              newCropArea.height = initialCropArea.y + initialCropArea.height - newCropArea.y;
              break;
            case 'top-right':
              newCropArea.y = Math.max(0, Math.min(initialCropArea.y + deltaY, initialCropArea.y + initialCropArea.height - 50));
              newCropArea.width = Math.max(50, Math.min(initialCropArea.width + deltaX, rect.width - initialCropArea.x));
              newCropArea.height = initialCropArea.y + initialCropArea.height - newCropArea.y;
              break;
            case 'bottom-left':
              newCropArea.x = Math.max(0, Math.min(initialCropArea.x + deltaX, initialCropArea.x + initialCropArea.width - 50));
              newCropArea.width = initialCropArea.x + initialCropArea.width - newCropArea.x;
              newCropArea.height = Math.max(50, Math.min(initialCropArea.height + deltaY, rect.height - initialCropArea.y));
              break;
            case 'bottom-right':
              newCropArea.width = Math.max(50, Math.min(initialCropArea.width + deltaX, rect.width - initialCropArea.x));
              newCropArea.height = Math.max(50, Math.min(initialCropArea.height + deltaY, rect.height - initialCropArea.y));
              break;
            case 'top':
              newCropArea.y = Math.max(0, Math.min(initialCropArea.y + deltaY, initialCropArea.y + initialCropArea.height - 50));
              newCropArea.height = initialCropArea.y + initialCropArea.height - newCropArea.y;
              break;
            case 'bottom':
              newCropArea.height = Math.max(50, Math.min(initialCropArea.height + deltaY, rect.height - initialCropArea.y));
              break;
            case 'left':
              newCropArea.x = Math.max(0, Math.min(initialCropArea.x + deltaX, initialCropArea.x + initialCropArea.width - 50));
              newCropArea.width = initialCropArea.x + initialCropArea.width - newCropArea.x;
              break;
            case 'right':
              newCropArea.width = Math.max(50, Math.min(initialCropArea.width + deltaX, rect.width - initialCropArea.x));
              break;
            default:
              break;
          }
          
          setCropArea(newCropArea);
        }
      };

      const handleGlobalMouseUp = () => {
        setIsDragging(false);
        setIsResizing(false);
        setResizeHandle(null);
        setInitialCropArea(null);
      };

      // Prevenir el scroll en dispositivos móviles durante el recorte
      const preventScroll = (e) => {
        if (isDragging || isResizing) {
          e.preventDefault();
        }
      };

      document.addEventListener('mousemove', handleGlobalMouseMove);
      document.addEventListener('mouseup', handleGlobalMouseUp);
      document.addEventListener('touchmove', handleGlobalMouseMove, { passive: false });
      document.addEventListener('touchend', handleGlobalMouseUp);
      document.addEventListener('touchmove', preventScroll, { passive: false });

      return () => {
        document.removeEventListener('mousemove', handleGlobalMouseMove);
        document.removeEventListener('mouseup', handleGlobalMouseUp);
        document.removeEventListener('touchmove', handleGlobalMouseMove);
        document.removeEventListener('touchend', handleGlobalMouseUp);
        document.removeEventListener('touchmove', preventScroll);
      };
    }
  }, [showCropModal, imageLoaded, isDragging, isResizing, cropArea, dragOffset, initialCropArea, resizeHandle]);

  // Prevenir scroll del body cuando el modal está abierto
  useEffect(() => {
    if (showCropModal) {
      const originalStyle = window.getComputedStyle(document.body).overflow;
      document.body.style.overflow = 'hidden';
      document.body.style.touchAction = 'none';
      
      return () => {
        document.body.style.overflow = originalStyle;
        document.body.style.touchAction = '';
      };
    }
  }, [showCropModal]);

  // Prevenir scroll del body cuando el modal de vista previa está abierto
  useEffect(() => {
    if (showPreviewModal) {
      const originalOverflow = document.body.style.overflow;
      const originalTouchAction = document.body.style.touchAction;
      document.body.style.overflow = 'hidden';
      document.body.style.touchAction = 'none';

      return () => {
        document.body.style.overflow = originalOverflow;
        document.body.style.touchAction = originalTouchAction || '';
      };
    }
  }, [showPreviewModal]);

  
  useEffect(() => {
    const check = () => setIsShortScreen(window.innerHeight <= 700);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  // Funciones para cambio de foto de perfil (simplificadas)
  const handleImageClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Validar tipo de archivo
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
    if (!allowedTypes.includes(file.type)) {
      alert('Por favor, selecciona una imagen válida (JPEG, PNG o GIF)');
      return;
    }

    // Validar tamaño (máximo 5MB)
    const maxSize = 5 * 1024 * 1024; // 5MB
    if (file.size > maxSize) {
      alert('La imagen debe ser menor a 5MB');
      return;
    }

    // Crear URL para la imagen
    const imageUrl = URL.createObjectURL(file);
    setSelectedImage({ file, url: imageUrl });
    setShowCropModal(true);
    setIsProcessingCrop(false);
    
    // Limpiar el input
    event.target.value = '';
  };

  const handleCropCancel = () => {
    setShowCropModal(false);
    setImageLoaded(false);
    setIsProcessingCrop(false);
    if (selectedImage) {
      URL.revokeObjectURL(selectedImage.url);
      setSelectedImage(null);
    }
  };

  // 1. Handler para iniciar movimiento del área de recorte
  const handleCropAreaMouseDown = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!imageRef.current || !imageLoaded) return;
    
    const rect = imageRef.current.getBoundingClientRect();
    let clientX, clientY;
    
    // Manejar tanto eventos de mouse como táctiles
    if (e.touches && e.touches[0]) {
      clientX = e.touches[0].clientX;
      clientY = e.touches[0].clientY;
    } else {
      clientX = e.clientX;
      clientY = e.clientY;
    }
    
    const mouseX = clientX - rect.left;
    const mouseY = clientY - rect.top;
    
    setIsDragging(true);
    setDragOffset({
      x: mouseX - cropArea.x,
      y: mouseY - cropArea.y
    });
  };

  // 2. Handler para iniciar redimensionamiento desde un handle
  const handleResizeHandleMouseDown = (handle) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!imageRef.current || !imageLoaded) return;
    
    const rect = imageRef.current.getBoundingClientRect();
    let clientX, clientY;
    
    // Manejar tanto eventos de mouse como táctiles
    if (e.touches && e.touches[0]) {
      clientX = e.touches[0].clientX;
      clientY = e.touches[0].clientY;
    } else {
      clientX = e.clientX;
      clientY = e.clientY;
    }
    
    const mouseX = clientX - rect.left;
    const mouseY = clientY - rect.top;
    
    setIsResizing(true);
    setResizeHandle(handle);
    setInitialCropArea({ ...cropArea });
    setDragOffset({
      x: mouseX - cropArea.x,
      y: mouseY - cropArea.y
    });
  };

  const handleCropAccept = async () => {
    if (!selectedImage) return;
    
    // Verificar que la imagen siga montada y cargada
    if (!imageRef.current || !imageLoaded) {
      alert('La imagen no está lista para recortar. Por favor, vuelve a intentarlo.');
      return;
    }
    
    setIsProcessingCrop(true);
    setIsUploadingImage(true);

    try {
      // Crear un canvas para recortar la imagen
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const img = new Image();
      
      img.onload = async () => {
        // Obtener las dimensiones reales de la imagen y del contenedor
        const imgRect = imageRef.current ? imageRef.current.getBoundingClientRect() : null;
        if (!imgRect) {
          alert('No se pudo obtener la referencia de la imagen.');
          setIsUploadingImage(false);
          setIsProcessingCrop(false);
          return;
        }
        const imgNaturalWidth = img.naturalWidth;
        const imgNaturalHeight = img.naturalHeight;
        const imgDisplayWidth = imgRect.width;
        const imgDisplayHeight = imgRect.height;
        
        // Calcular las escalas
        const scaleX = imgNaturalWidth / imgDisplayWidth;
        const scaleY = imgNaturalHeight / imgDisplayHeight;
        
        // Calcular las coordenadas reales en la imagen original
        const realCropX = cropArea.x * scaleX;
        const realCropY = cropArea.y * scaleY;
        const realCropWidth = cropArea.width * scaleX;
        const realCropHeight = cropArea.height * scaleY;
        
        // Configurar el canvas con el tamaño del recorte
        canvas.width = realCropWidth;
        canvas.height = realCropHeight;
        
        // Dibujar la parte recortada usando las coordenadas reales
        ctx.drawImage(
          img,
          realCropX, realCropY, realCropWidth, realCropHeight,
          0, 0, realCropWidth, realCropHeight
        );
        
        // Convertir el canvas a blob
        canvas.toBlob(async (blob) => {
          try {
            const formData = new FormData();
            formData.append('file', blob, 'cropped-image.jpg');

            const token = await getToken();
            if (!token) {
              setIsUploadingImage(false);
              setIsProcessingCrop(false);
              setShowCropModal(false);
              setMensaje("Error: No se pudo obtener el token de autenticación");
              navigate("/authentication/sign-in");
              return;
            }
            
            const response = await fetch(`${baseURL}/upload-profesional-image`, {
              method: 'POST',
              headers: {
                'Authorization': `Bearer ${token}`,
              },
              body: formData,
            });

            if (!response.ok) {
              const errorData = await response.json().catch(() => ({}));
              throw new Error(errorData.error || `Error HTTP: ${response.status}`);
            }

            const data = await response.json();
            
            setProfesionalData(prevData => ({
              ...prevData,
              imagen: data.url_original
            }));

            setMensaje("Foto de perfil actualizada correctamente");
          } catch (error) {
            console.error('Error al subir la imagen:', error);
            setMensaje(`Error al subir la imagen: ${error.message}`);
          } finally {
            setIsUploadingImage(false);
            setIsProcessingCrop(false);
            setShowCropModal(false);
          }
        }, 'image/jpeg', 0.9);
      };
      
      img.src = selectedImage.url;
      
    } catch (error) {
      console.error('Error al procesar la imagen:', error);
      setMensaje('Error al procesar la imagen. Por favor, intenta de nuevo.');
      setIsUploadingImage(false);
      setIsProcessingCrop(false);
      setShowCropModal(false);
    }
  };

  const handleSave = async () => {
    // Validar longitud de descripción
    if (descripcion.length > 250) {
      setMensaje("La descripción no puede exceder los 250 caracteres.");
      return;
    }

    // Validar número de especialidades
    if (profesion === "Psicólogo Online" && especialidades.length > 10) {
      setMensaje("No puedes seleccionar más de 10 especialidades.");
      return;
    }

    setIsLoading(true);
    try {
      const payload = {
        descripcion,
        profesion,
      };

      if (profesion === "Psicólogo Online" && especialidades.length > 0) {
        payload.labels = especialidades;
      }

      const token = await getToken();
      if (!token) {
        setMensaje("Error: No se pudo obtener el token de autenticación");
        navigate("/authentication/sign-in");
        setIsLoading(false);
        return;
      }
      
      const profesionalId = localStorage.getItem('id');
      
      await fetch(`${baseURL}/actualizar-profesional/${profesionalId}`, {
        method: 'PUT',
        headers: { 
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });
      
      // Actualizar el contexto local
      updateLocalData(payload);
      
      setMensaje("Datos actualizados con éxito");
    } catch (error) {
      setMensaje("Hubo un error al actualizar los datos. Por favor, inténtalo nuevamente.");
    } finally {
      setIsLoading(false);
    }
  };

  const getEspecialidadLabel = (value) => {
    const especialidad = especialidadesData.find(esp => esp.value === value);
    return especialidad ? especialidad.label : value;
  };

  // Función para obtener los honorarios tal como están
  const obtenerHonorarios = () => {
    return honorarios || 0;
  };

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: 'white',
      padding: '20px',
      paddingBottom: '100px', // Espacio para el BottomTabBar (80px + 20px extra)
      fontFamily: 'system-ui, -apple-system, sans-serif'
    }}>
      <style>{`
        /* Preview modal responsive */
        .pf-previewOverlay { position: fixed; inset: 0; background: rgba(0,0,0,.5); display: flex; align-items: center; justify-content: center; z-index: 1000; padding: min(20px, 4vw); }
        .pf-previewModal { width: clamp(360px, 92vw, 1200px); min-height: clamp(420px, 64vh, 900px); max-height: 92vh; height: auto; background: #fff; border-radius: 12px; overflow: hidden; display: flex; flex-direction: column; }
        .pf-previewHeader { display: flex; align-items: center; padding: clamp(12px, 2.6vmin, 22px) clamp(16px, 3.4vmin, 28px); border-bottom: 1px solid #eee; background: #f8f9fa; }
        .pf-previewTitle { font-weight: 700; color: #000; font-size: clamp(18px, 2.4vmin, 26px); margin: 0; font-family: system-ui, -apple-system, sans-serif; }
        .pf-previewBody { padding: clamp(16px, 3vmin, 40px); overflow: hidden; }
        .pf-previewCard { border-radius: 16px; box-shadow: 0 4px 20px rgba(0,0,0,.1); background: #fff; overflow: hidden; position: relative; }
        .pf-deco { position: absolute; left: 0; top: 0; width: 80px; height: 40px; z-index: 1; }
        .pf-avatar { width: clamp(96px, 18vmin, 160px); height: clamp(96px, 18vmin, 160px); border-radius: 50%; object-fit: cover; box-shadow: 0 4px 12px rgba(0,0,0,.15); border: 4px solid #fff; margin-bottom: clamp(10px, 2vmin, 18px); }
        .pf-name { font-size: clamp(18px, 2.6vmin, 28px); font-weight: 700; color: rgb(147, 143, 127); margin: 0 0 8px 0; font-family: system-ui, -apple-system, sans-serif; }
        .pf-description { font-size: clamp(14px, 2.2vmin, 20px); color: #666; line-height: 1.5; margin: 0 0 12px 0; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 8; overflow: hidden; }
        .pf-chips { display: flex; flex-wrap: wrap; gap: 6px; }

        @media (max-height: 700px) {
          .pf-deco { display: none; }
          .pf-previewTitle { font-size: 16px; }
          .pf-name { font-size: 16px; }
          .pf-description { -webkit-line-clamp: 3; font-size: 12px; }
        }

        @media (max-height: 600px) {
          .pf-deco { display: none; }
          .pf-description { -webkit-line-clamp: 4; }
          .pf-avatar { width: clamp(64px, 16vh, 96px); height: clamp(64px, 16vh, 96px); }
          .pf-previewBody { padding: 12px; }
        }

        @media (max-height: 500px) {
          .pf-description { -webkit-line-clamp: 3; }
        }

        @media (min-width: 700px) {
          .pf-previewBody { padding: clamp(16px, 3vmin, 32px); }
          .pf-description { -webkit-line-clamp: 8; }
        }

        @media (min-width: 900px) and (min-height: 700px) {
          .pf-previewBody { padding: clamp(20px, 3.2vmin, 48px); }
          .pf-description { -webkit-line-clamp: 10; }
        }

        @media (min-width: 1200px) and (min-height: 800px) {
          .pf-previewModal { width: clamp(420px, 86vw, 1200px); }
          .pf-description { -webkit-line-clamp: 12; }
        }
      `}</style>
      {/* Header */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        marginBottom: '5px',
        position: 'relative'
      }}>
        <IconButton 
          onClick={() => navigate('/perfil')}
          sx={{ 
            color: "#000",
            padding: '8px',
            marginRight: '16px'
          }}
        >
          <ArrowBackIcon />
        </IconButton>
        <h1 style={{ 
          fontWeight: 'bold',
          color: '#000',
          fontSize: '20px',
          margin: 0,
          fontFamily: 'system-ui, -apple-system, sans-serif'
        }}>
          Mi descripción / datos
        </h1>
      </div>

      {/* Mensaje de estado */}
      {mensaje && (
        <div style={{
          backgroundColor: mensaje.includes('Error') ? '#ffebee' : '#e8f5e8',
          color: mensaje.includes('Error') ? '#c62828' : '#2e7d32',
          padding: '12px 16px',
          borderRadius: '8px',
          marginBottom: '20px',
          fontSize: '14px',
          textAlign: 'center'
        }}>
          {mensaje}
        </div>
      )}

      {/* Card principal */}
      <div style={{ 
        width: '100%', 
        maxWidth: '400px',
        margin: '0 auto',
        borderRadius: '20px', 
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)', 
        backgroundColor: 'white',
        overflow: 'hidden',
        padding: '20px'
      }}>
        {/* Foto de perfil */}
        <div style={{ marginBottom: '24px' }}>
          <Typography variant="h6" sx={{ color: '#000', fontSize: '16px', fontWeight: 'bold', marginBottom: '12px' }}>
            Foto de perfil
          </Typography>
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            <div style={{ position: 'relative' }}>
              <img
                src={profesionalData.imagen || (profesionalData.genero === 'F'
                  ? 'https://i.ibb.co/FBnpswy/young-smiling-woman-mia-avatar-260nw-2127358541.jpg'
                  : 'https://iili.io/3xJfssa.th.png')}
                alt={`${profesionalData.nombre} ${profesionalData.apellido}`}
                onClick={handleImageClick}
                style={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '50%',
                  objectFit: 'cover',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                  border: '3px solid white',
                  cursor: 'pointer',
                  opacity: isUploadingImage ? 0.6 : 1,
                  transition: 'opacity 0.3s ease'
                }}
              />
              {isUploadingImage && (
                <div style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  color: '#0096dc',
                  fontWeight: 'bold',
                  fontSize: '12px'
                }}>
                  Subiendo...
                </div>
              )}
            </div>
            <Button
              variant="outlined"
              onClick={handleImageClick}
              startIcon={<EditIcon />}
              sx={{
                color: '#0096dc',
                borderColor: '#0096dc',
                borderRadius: '8px',
                textTransform: 'none',
                fontWeight: 'bold'
              }}
            >
              Editar
            </Button>
          </div>
        </div>

        {/* Describe tus servicios */}
        <div style={{ marginBottom: '24px' }}>
          <Typography variant="h6" sx={{ color: '#000', fontSize: '16px', fontWeight: 'bold', marginBottom: '12px' }}>
            Describe tus servicios
          </Typography>
          <TextField
            fullWidth
            multiline
            rows={4}
            value={descripcion}
            onChange={(e) => setDescripcion(e.target.value)}
            placeholder="Ofrezo servicios de..."
            variant="outlined"
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: '12px',
                backgroundColor: '#f8f9fa'
              }
            }}
          />
          <Typography variant="caption" sx={{ color: '#666', fontSize: '12px', textAlign: 'right', display: 'block', marginTop: '4px' }}>
            {descripcion.length}/250 caracteres
          </Typography>
          
          {/* Botón de vista previa */}
          <Button
            variant="outlined"
            onClick={() => setShowPreviewModal(true)}
            sx={{
              color: '#0096dc',
              borderColor: '#0096dc',
              borderRadius: '8px',
              textTransform: 'none',
              fontWeight: 'bold',
              marginTop: '12px',
              width: '100%'
            }}
          >
            Vista previa
          </Button>
        </div>

        {/* Etiquetas - Solo para Psicólogo Online */}
        {profesion === "Psicólogo Online" && (
          <div style={{ marginBottom: '24px' }}>
            <Typography variant="h6" sx={{ color: '#000', fontSize: '16px', fontWeight: 'bold', marginBottom: '12px' }}>
              Etiquetas
            </Typography>
            <TextField
              fullWidth
              value={etiquetas}
              onChange={(e) => setEtiquetas(e.target.value)}
              placeholder="Separadas por una coma"
              variant="outlined"
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '12px',
                  backgroundColor: '#f8f9fa'
                }
              }}
            />
            <Typography variant="caption" sx={{ color: '#666', fontSize: '12px', textAlign: 'right', display: 'block', marginTop: '4px' }}>
              10 etiquetas max
            </Typography>
          </div>
        )}


        {/* Tipo de consulta */}
        <div style={{ marginBottom: '24px' }}>
          <Typography variant="h6" sx={{ color: '#000', fontSize: '16px', fontWeight: 'bold', marginBottom: '12px' }}>
            Tipo de consulta:
          </Typography>
          <div style={{ display: 'flex', gap: '12px' }}>
            <Chip
              label="Online"
              sx={{
                backgroundColor: '#EBFFF0',
                color: '#00AD62',
                fontWeight: 'bold',
                borderRadius: '20px',
                padding: '8px 16px'
              }}
            />
            <Chip
              label="Uruguay"
              sx={{
                backgroundColor: '#E3F2FD',
                color: '#1976D2',
                fontWeight: 'bold',
                borderRadius: '20px',
                padding: '8px 16px'
              }}
            />
          </div>
        </div>

        {/* Especialidades seleccionadas */}
        {especialidades.length > 0 && (
          <div style={{ marginBottom: '24px' }}>
            <Typography variant="h6" sx={{ color: '#000', fontSize: '16px', fontWeight: 'bold', marginBottom: '12px' }}>
              Especialidades seleccionadas:
            </Typography>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
              {especialidades.map((label, idx) => (
                <Chip
                  key={idx}
                  label={getEspecialidadLabel(label)}
                  sx={{
                    backgroundColor: '#e9ecef',
                    color: '#495057',
                    fontSize: '12px',
                    fontWeight: 500
                  }}
                />
              ))}
            </div>
          </div>
        )}

        {/* Botón Guardar */}
        <Button
          fullWidth
          variant="contained"
          onClick={handleSave}
          disabled={isLoading}
          sx={{
            backgroundColor: '#1F85F6',
            color: 'white !important',
            borderRadius: '12px',
            textTransform: 'none',
            fontWeight: 'bold',
            padding: '12px',
            fontSize: '16px',
            '&:hover': {
              backgroundColor: '#1F85F6',
              opacity: 0.9,
              color: 'white !important'
            },
            '&.MuiButton-root': {
              color: 'white !important'
            }
          }}
        >
          {isLoading ? 'Guardando...' : 'Guardar'}
        </Button>
      </div>

      {/* Input file oculto para seleccionar imagen */}
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        onChange={handleFileSelect}
        style={{ display: 'none' }}
      />

      {/* Modal de recorte de imagen simplificado */}
      {showCropModal && selectedImage && (
        <div
          onClick={handleCropCancel}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              maxWidth: '400px',
              width: '90%',
              background: 'white',
              borderRadius: '12px',
              padding: '20px'
            }}
          >
            <Typography variant="h6" sx={{ mb: 2, textAlign: 'center' }}>
              Recortar imagen
            </Typography>
            <div style={{
              position: 'relative',
              display: 'inline-block',
              margin: '20px 0',
              border: '2px solid #ddd',
              borderRadius: '8px',
              overflow: 'hidden',
              touchAction: 'none'
            }}>
              <img
                ref={imageRef}
                src={selectedImage.url}
                alt="Preview"
                onLoad={() => setImageLoaded(true)}
                style={{
                  maxWidth: '100%',
                  maxHeight: '300px',
                  display: 'block',
                  userSelect: 'none',
                  WebkitUserSelect: 'none',
                  MozUserSelect: 'none',
                  msUserSelect: 'none',
                  pointerEvents: 'auto',
                  touchAction: 'none'
                }}
                draggable={false}
              />
              {/* Área de recorte */}
              <div
                style={{
                  position: 'absolute',
                  left: cropArea.x,
                  top: cropArea.y,
                  width: cropArea.width,
                  height: cropArea.height,
                  border: '2px solid #0096dc',
                  backgroundColor: 'rgba(0, 150, 220, 0.1)',
                  cursor: isDragging ? 'grabbing' : 'move',
                  boxSizing: 'border-box',
                  zIndex: 2,
                  touchAction: 'none'
                }}
                onMouseDown={handleCropAreaMouseDown}
                onTouchStart={handleCropAreaMouseDown}
              >
                {/* Handles de redimensionamiento */}
                {['top-left', 'top-right', 'bottom-left', 'bottom-right', 'top', 'bottom', 'left', 'right'].map(handle => (
                  <div
                    key={handle}
                    style={{
                      position: 'absolute',
                      width: '20px',
                      height: '20px',
                      backgroundColor: '#0096dc',
                      border: '1px solid white',
                      cursor: handle.includes('top') && handle.includes('left') ? 'nw-resize' :
                        handle.includes('top') && handle.includes('right') ? 'ne-resize' :
                          handle.includes('bottom') && handle.includes('left') ? 'sw-resize' :
                            handle.includes('bottom') && handle.includes('right') ? 'se-resize' :
                              handle === 'top' || handle === 'bottom' ? 'ns-resize' : 'ew-resize',
                      left: handle.includes('left') ? '-10px' : handle.includes('right') ? 'calc(100% - 10px)' : 'calc(50% - 10px)',
                      top: handle.includes('top') ? '-10px' : handle.includes('bottom') ? 'calc(100% - 10px)' : 'calc(50% - 10px)',
                      zIndex: 3,
                      touchAction: 'none'
                    }}
                    onMouseDown={handleResizeHandleMouseDown(handle)}
                    onTouchStart={handleResizeHandleMouseDown(handle)}
                  />
                ))}
              </div>
            </div>
            <Typography variant="body2" sx={{ fontSize: '14px', color: '#666', mb: 2, textAlign: 'center' }}>
              Arrastra el área de recorte para moverla o usa las esquinas para redimensionarla
            </Typography>
            <Box display="flex" gap={2} justifyContent="center">
              <Button
                onClick={handleCropCancel}
                disabled={isProcessingCrop}
                variant="outlined"
                color="error"
              >
                Cancelar
              </Button>
              <Button
                onClick={handleCropAccept}
                disabled={isProcessingCrop}
                variant="contained"
                color="primary"
              >
                {isProcessingCrop ? 'Procesando...' : 'Aceptar'}
              </Button>
            </Box>
          </div>
        </div>
      )}

      {/* Modal de vista previa */}
      {showPreviewModal && (
        <div
          onClick={() => setShowPreviewModal(false)}
          className="pf-previewOverlay"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="pf-previewModal"
            role="dialog"
            aria-modal="true"
            aria-label="Vista previa de tu perfil"
          >
            {/* Header del modal */}
            <div className="pf-previewHeader">
              <IconButton 
                onClick={() => setShowPreviewModal(false)}
                sx={{ color: '#000', padding: '8px', marginRight: '12px' }}
                aria-label="Cerrar vista previa"
              >
                <ArrowBackIcon />
              </IconButton>
              <h2 className="pf-previewTitle">Vista previa de tu perfil</h2>
            </div>

            {/* Contenido del modal - Responsive, sin scroll interno */}
            <div className="pf-previewBody">
              <div className="pf-previewCard">
                {/* SVG decorativo (oculto en pantallas muy bajas) */}
                <svg
                  className="pf-deco"
                  viewBox="0 0 80 40"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <ellipse cx="0" cy="0" rx="80" ry="40" fill="#e2f2f1" />
                </svg>

                {/* Foto del profesional */}
                <div style={{ textAlign: 'center', padding: '20px 20px 0' }}>
                  <img
                    className="pf-avatar"
                    src={
                      profesionalData.imagen || (profesionalData.genero === 'F'
                        ? 'https://i.ibb.co/FBnpswy/young-smiling-woman-mia-avatar-260nw-2127358541.jpg'
                        : 'https://iili.io/3xJfssa.th.png')
                    }
                    alt={`${profesionalData.nombre} ${profesionalData.apellido}`}
                  />
                </div>

                {/* Tipo de consulta */}
                <div style={{ padding: '0 20px 12px', textAlign: 'center' }}>
                  <div style={{ fontSize: '14px', color: '#666', marginBottom: '8px' }}>
                    Tipo de consulta:
                  </div>
                  <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                    <button style={{
                      backgroundColor: '#c4e6d5',
                      color: '#238b64',
                      border: 'none',
                      borderRadius: '20px',
                      padding: 'clamp(6px, 1.6vmin, 10px) clamp(10px, 3vmin, 16px)',
                      fontSize: 'clamp(12px, 2vmin, 16px)',
                      fontWeight: 'bold'
                    }}>
                      {profesion === 'Directorio Médico' ? 'PRESENCIAL' : 'ONLINE'}
                    </button>
                    <button style={{
                      backgroundColor: '#fdbdb4',
                      color: 'white',
                      border: 'none',
                      borderRadius: '20px',
                      padding: 'clamp(6px, 1.6vmin, 10px) clamp(10px, 3vmin, 16px)',
                      fontSize: 'clamp(12px, 2vmin, 16px)',
                      fontWeight: 'bold'
                    }}>
                      URUGUAY
                    </button>
                  </div>
                </div>

                {/* Información del profesional */}
                <div style={{ padding: '0 20px 16px' }}>
                  <hr style={{
                    border: 'none',
                    height: '1px',
                    background: 'linear-gradient(90deg, transparent, #ccc, transparent)',
                    margin: 'clamp(12px, 1.6vh, 16px) 0',
                    width: '100%'
                  }} />
                  
                  <h3 className="pf-name">
                    {profesionalData.nombre} {profesionalData.apellido}
                  </h3>

                  <p className="pf-description">
                    {descripcion || 'No hay descripción disponible'}
                  </p>

                  <button style={{
                    backgroundColor: profesion === 'Nutricionista' ? '#fdbdb4' : '#f8f9fa',
                    color: profesion === 'Nutricionista' ? 'white' : '#495057',
                    border: profesion === 'Nutricionista' ? 'none' : '1px solid #dee2e6',
                    borderRadius: '20px',
                    padding: 'clamp(6px, 1.6vmin, 10px) clamp(10px, 3vmin, 16px)',
                    fontSize: 'clamp(12px, 2vmin, 16px)',
                    fontWeight: 'bold',
                    marginBottom: 'clamp(10px, 1.6vmin, 16px)'
                  }}>
                    {profesion === 'Psicólogo Online' ? 'Lic.Psicología' : 
                     profesion === 'Directorio Médico' ? 'Dr.Medicina' : 
                     profesion === 'Nutricionista' ? 'Lic.Nutrición' : 'Lic.Psicología'}
                  </button>

                  {/* Especialidades seleccionadas (limitadas visualmente) */}
                  {especialidades.length > 0 && (
                    <div style={{ marginBottom: 'clamp(8px, 1.2vh, 12px)' }}>
                      <div className="pf-chips">
                        {especialidades.slice(0, isShortScreen ? 4 : 6).map((label, idx) => (
                          <span
                            key={idx}
                            style={{
                              backgroundColor: '#e9ecef',
                              color: '#495057',
                              fontSize: '11px',
                              fontWeight: 500,
                              padding: '4px 8px',
                              borderRadius: '12px',
                              border: '1px solid #dee2e6'
                            }}
                          >
                            {getEspecialidadLabel(label)}
                          </span>
                        ))}
                        {especialidades.length > (isShortScreen ? 4 : 6) && (
                          <span style={{
                            backgroundColor: '#e9ecef',
                            color: '#495057',
                            fontSize: '11px',
                            fontWeight: 500,
                            padding: '4px 8px',
                            borderRadius: '12px',
                            border: '1px solid #dee2e6'
                          }}>
                            +{especialidades.length - (isShortScreen ? 4 : 6)} más
                          </span>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Información de contacto o precio */}
                  {profesion === 'Directorio Médico' ? (
                    <div style={{
                      backgroundColor: '#f8f9fa',
                      borderRadius: '12px',
                      padding: '16px',
                      marginTop: '12px'
                    }}>
                      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
                        <div style={{
                          width: '40px',
                          height: '40px',
                          backgroundColor: '#25D366',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          marginRight: '12px'
                        }}>
                          <span style={{ color: 'white', fontSize: '18px' }}>📱</span>
                        </div>
                        <div>
                          <div style={{ fontSize: '12px', color: '#666' }}>WhatsApp</div>
                          <div style={{ fontSize: '14px', fontWeight: 'bold', color: '#000' }}>
                            {profesionalData.celular || '098 589 701'}
                          </div>
                        </div>
                      </div>
                      
                      <button style={{
                        width: '100%',
                        backgroundColor: '#25D366',
                        color: 'white',
                        border: 'none',
                        borderRadius: '8px',
                        padding: '12px',
                        fontSize: '14px',
                        fontWeight: 'bold',
                        cursor: 'pointer'
                      }}>
                        Contactar
                      </button>
                    </div>
                  ) : (
                    <>
                      <div style={{
                        background: 'white',
                        borderRadius: '8px',
                        padding: 'clamp(12px, 2vh, 16px)',
                        margin: 'clamp(12px, 1.8vh, 16px) 0 clamp(10px, 1.6vh, 12px) 0',
                        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                        border: '1px solid #e1e5e9',
                        position: 'relative',
                        overflow: 'hidden'
                      }}>
                        <div style={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          width: '4px',
                          height: '100%',
                          background: '#7eccbc'
                        }}></div>
                        
                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          gap: '12px'
                        }}>
                          <div style={{ flex: 1 }}>
                            <div style={{
                              display: 'flex',
                              alignItems: 'baseline',
                              gap: '8px',
                              marginBottom: '4px'
                            }}>
                              <span style={{
                                fontSize: 'clamp(24px, 3vmin, 32px)',
                                fontWeight: 'bold',
                                color: 'rgb(126, 204, 188)'
                              }}>
                                ${obtenerHonorarios()}
                              </span>
                            </div>
                            <div style={{
                              textAlign: 'left',
                              marginLeft: 0,
                              paddingLeft: '2px',
                              fontSize: 'clamp(12px, 1.8vmin, 14px)',
                              color: 'rgb(127, 140, 141)'
                            }}>
                              POR CONSULTA
                            </div>
                          </div>
                        </div>
                      </div>
                      
                      <button style={{
                        width: '100%',
                        backgroundColor: 'rgb(109, 186, 170)',
                        color: 'white',
                        border: 'none',
                        borderRadius: '8px',
                        padding: 'clamp(12px, 2vmin, 16px)',
                        fontSize: 'clamp(14px, 2vmin, 18px)',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        marginTop: 'clamp(6px, 1.2vh, 8px)'
                      }}>
                        Agendar Cita
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MiDescripcion;
